import { render, staticRenderFns } from "./StatMetricCard.vue?vue&type=template&id=2ba9283f&"
import script from "./StatMetricCard.vue?vue&type=script&lang=js&"
export * from "./StatMetricCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports